// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X4Qq","icon":"styles_icon__2gu0p"};